import { render, staticRenderFns } from "./NavOverlayCompactScreen.vue?vue&type=template&id=20509cb3&scoped=true&"
import script from "./NavOverlayCompactScreen.vue?vue&type=script&lang=js&"
export * from "./NavOverlayCompactScreen.vue?vue&type=script&lang=js&"
import style0 from "./NavOverlayCompactScreen.vue?vue&type=style&index=0&id=20509cb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20509cb3",
  null
  
)

export default component.exports